import { connectorsApi } from '../services/connectorsApi';

type AnyFlow = {
  id?: string;
  key?: string;
  name?: string;
};

export const runConnectionFlow = async (
  integrationApp: any,
  connectionId: string,
  flowKey: string,
  payload: Record<string, unknown> = {},
) => {
  try {
    await integrationApp.connection(connectionId).flow(flowKey).get({ autoCreate: true });
    await integrationApp.connection(connectionId).flow(flowKey).enable();
    await integrationApp.connection(connectionId).flow(flowKey).run(payload);
  } catch (e) {
    // best-effort only
  }
};

const isInitialSyncCandidate = (flow: AnyFlow) => {
  const haystack = `${flow?.key || ""} ${flow?.name || ""}`.toLowerCase();
  return haystack.includes("first-sync") || haystack.includes("initial-sync");
};

export const triggerBestEffortInitialSync = async (
  integrationApp: any,
  connectionId: string,
) => {
  try {
    const flows: AnyFlow[] = await integrationApp.connection(connectionId).flows.findAll();
    const candidates = flows.filter(isInitialSyncCandidate);
    if (!candidates.length) return;

    await Promise.allSettled(
      candidates.map((flow) => {
        const selector = flow.key || flow.id;
        if (!selector) return Promise.resolve(null);
        return runConnectionFlow(integrationApp, connectionId, selector);
      }),
    );
  } catch (e) {
    // best-effort only
  }
};

/**
 * Optimistically notify the backend that a Membrane connection just completed OAuth.
 * The backend webhook is the source of truth, but this POST provides fast UI feedback.
 */
export const notifyBackendOfConnection = async (
  workspaceId: string,
  provider: string,
  connectionId: string,
  primaryEmail: string,
  externalAccountId?: string,
) => {
  try {
    await connectorsApi.connectionCreated(workspaceId, provider, {
      connection_id: connectionId,
      primary_email: primaryEmail,
      external_account_id: externalAccountId,
    });
  } catch (e) {
    // Not fatal — webhook path is canonical and will populate if this call fails.
    // eslint-disable-next-line no-console
    console.warn('optimistic connection-created POST failed', e);
  }
};

export default runConnectionFlow;
